import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { MemoryPage, type MemoryTab } from "../../../components/admin/memory/MemoryPage";

// The Memory admin page (PLAN §8.3, D15; R5 contract 10, 11, 15, 19). The tab and the open fact
// live in the URL, so a link opens the same view.

type Search = { tab?: Exclude<MemoryTab, "facts">; id?: string };

const TABS = new Set(["lessons", "briefing", "review"]);

export const Route = createFileRoute("/_app/admin/memory")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    ...(typeof s.tab === "string" && TABS.has(s.tab)
      ? { tab: s.tab as Exclude<MemoryTab, "facts"> }
      : {}),
    ...(typeof s.id === "string" && s.id ? { id: s.id } : {}),
  }),
  component: Memory,
});

function Memory() {
  const { tab, id } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <MemoryPage
      tab={tab ?? "facts"}
      factId={id}
      onTab={(next) => navigate({ search: next === "facts" ? {} : { tab: next } })}
      onFact={(fid) => navigate({ search: fid ? { id: fid } : {}, replace: !fid })}
    />
  );
}
